import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./servicoOrdemCadastro.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getServicosOrdemById,
  getServicosOrdemCadastro,
  getServicosOrdemUpdate,
} from "../../services/api_cadastro_servico_ordem";
import { getServicos } from "../../services/api_servicos";
import { getSetoresExecutantes } from "../../services/api_setores_executantes";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const ServicoOrdemRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const idOrdem = location.state.idOrdem;
  const idPlano = location.state.idPlano;
  //console.log("idOrdem: ", idOrdem);
  //console.log("idPlano: ", idPlano);

  const [descricao, setDescricao] = useState("");
  const [programado, setProgramado] = useState("Não");
  const [status, setStatus] = useState("0");
  const [id_ordem_servico, setOrdemServico] = useState(idOrdem);
  const [id_servico, setServico] = useState("");
  const [id_setor_executante, setSetorExecutante] = useState("");
  const [servicos, setServicos] = useState([]);
  const [setores_executantes, setSetoresExecutantes] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Descricao: useRef(null),
    Programado: useRef(null),
    SetorExecutante: useRef(null),
    status: useRef(null),
    Servico: useRef(null),
    planosManutencao: useRef(null),
  };

  useEffect(() => {
    const fetchServicosOrdem = async () => {
      try {
        const response = await getServicosOrdemById(id);
        const servico_ordem = response.data.ServicosOrdem;
        if (servico_ordem) {
          setDescricao(servico_ordem.descricao || "");
          setProgramado(servico_ordem.programado ? "Sim" : "Não");
          setStatus(servico_ordem.status || "");
          setOrdemServico(servico_ordem.id_ordem_servico || "");
          setSetorExecutante(servico_ordem.id_setor_executante || "");
          setServico(servico_ordem.id_servico || "");
        } else {
          console.error("Dados não encontrados:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    if (id) {
      fetchServicosOrdem();
    }
  }, [id]);

  useEffect(() => {
    const fetchServicos = async () => {
      try {
        const response = await getServicos();
        if (response) {
          const servicosAtivos = response.data.Servicos.filter(
            (servico) => servico.deleted_at == null
          );
          setServicos(servicosAtivos);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    const fetchSetoresExecutantes = async () => {
      try {
        const response = await getSetoresExecutantes();
        if (response) {
          const setoresExecutantesAtivos =
            response.data.SetoresExecutantes.filter(
              (setorExecutante) => setorExecutante.deleted_at == null
            );
          setSetoresExecutantes(setoresExecutantesAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter setores executantes:", error);
      }
    };

    fetchServicos();
    fetchSetoresExecutantes();
    const interval = setInterval(()=>{
      fetchServicos();
      fetchSetoresExecutantes();
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (
      !descricao ||
      !id_ordem_servico ||
      !id_servico ||
      !id_setor_executante ||
      !programado ||
      !status
    ) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento de todos os campos é obrigatório.",
      });

      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getServicosOrdemCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar dados:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        );
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getServicosOrdemUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar dados:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        );
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      const body = {
        descricao,
        id_ordem_servico: idOrdem,
        id_servico,
        id_setor_executante,
        programado: programado === "Sim" ? 1 : 0,
        status: status,
      };
      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setDescricao(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 50 caracteres",
      });
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === "Enter" && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus =
        nextFieldRef.current.inputRef || nextFieldRef.current;

      if (typeof elementToFocus.focus === "function") {
        elementToFocus.focus();
      } else {
        console.warn("O elemento de input não tem o método focus.");
      }
    }
  };

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Serviços / Listagem de Ordens de Serviço / Execução / Cadastro de execução" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formDescricao">
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a descrição"
                    value={descricao}
                    onChange={handleCaracteres}
                    ref={inputRefs.Descricao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Programado)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formProgramado">
                  <Form.Label>Programado</Form.Label>
                  <Form.Select
                    disabled={idPlano ? true : false}
                    value={programado}
                    onChange={(e) => setProgramado(e.target.value)}
                    ref={inputRefs.Programado}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Servico)}
                  >
                    <option value="Não">Não</option>
                    <option value="Sim">Sim</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={status}
                    disabled={!id ? true : false}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="0">Pendente</option>
                    {id && (
                      <>
                        <option value="1">Executado</option>
                        <option value="2">Cancelado</option>
                      </>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formUniMedida">
                  <Form.Label>Serviço</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_servico}
                    onChange={(e) => setServico(e.target.value)}
                    ref={inputRefs.Servico}
                    onKeyDown={(e) =>
                      handleKeyDown(e, inputRefs.SetorExecutante)
                    }
                  >
                    <option value="">Selecione</option>
                    {servicos &&
                      servicos.map((id_servico) => (
                        <option key={id_servico.id} value={id_servico.id}>
                          {id_servico.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group controlId="formUniMedida">
                  <Form.Label>Setor Executante</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_setor_executante}
                    onChange={(e) => setSetorExecutante(e.target.value)}
                    ref={inputRefs.SetorExecutante}
                  >
                    <option value="">Selecione</option>
                    {setores_executantes &&
                      setores_executantes.map((id_setor_executante) => (
                        <option
                          key={id_setor_executante.id}
                          value={id_setor_executante.id}
                        >
                          {id_setor_executante.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default ServicoOrdemRegister;
